// extracted by mini-css-extract-plugin
export default {"container":"_VqfgC","title":"iun6xE","trips-title":"b9UBcc","subtitle":"K00zAm"};